import { useEffect } from 'react';
import { Toast } from '../helpers/popups/Toast';
import { TFailResponse } from '../types/general/TFailResponse';

export const useErrorHandling = (...errors: TFailResponse[]) => {
    useEffect(() => {
        errors.forEach(async (error) => {
            if (error) {
                let title = error.message ?? 'Something went wrong.';

                const { data } = error;

                if (data) {
                    if (data.errors && data.errors.length > 0) {
                        for (let i = 0; i < data.errors.length; i++) {
                            const em = data.errors[i];
                            await Toast.fire({
                                title: em,
                                icon: 'error',
                            });
                        }
                        return;
                    } else if (data.error) {
                        title = data.error;
                    } else if (data.message) {
                        title = data.message;
                    }
                }

                await Toast.fire({
                    title,
                    icon: 'error',
                    timer: 4500
                });
            }
        });
    }, [JSON.stringify(errors)]);
};
